module.exports = __webpack_public_path__ + "static/media/singleProductBcg.96758412.jpeg";